<mat-card>
  <mat-card-title>Activity Summary</mat-card-title>

  <mat-table [dataSource]="result" matSort>
    <ng-container matColumnDef="activityName">
      <mat-header-cell *matHeaderCellDef i18n>Activity Name</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.activity}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="hourlyCost">
      <mat-header-cell *matHeaderCellDef i18n>Cost/h(€)</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.hourlyCost | number:'1.2'}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="hours">
      <mat-header-cell *matHeaderCellDef i18n>H Budget</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.hours}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="cost">
      <mat-header-cell *matHeaderCellDef i18n>Tot Budget(€)</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.cost | number:'1.2'}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="finalHours">
      <mat-header-cell *matHeaderCellDef i18n>H Consunt</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.finalHours}}</span></mat-cell>
    </ng-container>
    <ng-container matColumnDef="finalCost">
      <mat-header-cell *matHeaderCellDef i18n>Tot Cons(€)</mat-header-cell>
      <mat-cell *matCellDef="let activity">
        <span>{{activity.finalCost | number:'1.2'}}</span></mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" [class.element-row]="true" [class.make-red]="row.finalCost > row.cost">
    </mat-row>
  </mat-table>
  <br>

  <table class="table table-bordered">
    <tr>
      <td></td>
      <td>Total Hours</td>
      <td>Total Cost</td>
    </tr>
    <!--Budget-->
    <tr>
      <td>Budget</td>
      <td>{{ totalHBudget }}</td>
      <td>{{ totalBudget | currency:'EUR':'symbol':'1.0-0' }}</td>
    </tr>
    <!--Consuntivo-->
    <tr>
      <td>Final</td>
      <td>{{ totalHFinal }}</td>
      <td>{{totalFinal | currency:'EUR':'symbol':'1.0-0' }}</td>
    </tr>
    <!--Difference-->
    <tr class="differences">
      <td>Difference</td>
      <td [class.make-red]="totalHBudget < totalHFinal">{{ totalHBudget - totalHFinal }}</td>
      <td [class.make-red]="totalBudget < totalFinal">{{ totalBudget - totalFinal | currency:'EUR':'symbol':'1.0-0' }}</td>
    </tr>
  </table>

  <!-- <div class="example-container mat-elevation-z8">

        <mat-table [dataSource]="dataSource" matSort>
      
          <ng-container matColumnDef="sent">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Sent</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span *ngIf="row.sent" [matTooltip]="row.sentOn"><mat-icon>mail</mat-icon></span>
              </mat-cell>
          </ng-container>
      
          <ng-container matColumnDef="budgetId">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Budget</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span *ngIf="row.budget.project">{{ row.budget | projectNr }}-</span>{{ row.budget.budgetNr }}</mat-cell>
          </ng-container>
      
      
          <ng-container matColumnDef="subBudgetId">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Sub Budget</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.subBudget.description }} </mat-cell>
          </ng-container>
      
      
          <ng-container matColumnDef="activityId">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Activity</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.activity.activity }} </mat-cell>
          </ng-container>
      
      
          <ng-container matColumnDef="hours">
            <mat-header-cell *matHeaderCellDef i18n>Hours</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.hours }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="hourlyCost">
              <mat-header-cell *matHeaderCellDef i18n>H.Cost</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.actualCost | currency:'EUR' }} </mat-cell>
           </ng-container>
      
      
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date (Europe/Rome Time)</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.date | date:mediumDate:'+0200' }}</mat-cell>
          </ng-container>
      
      
          <ng-container matColumnDef="userId">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n>User</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.user.displayName }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="totalValue">
              <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Cost</mat-header-cell>
              <mat-cell *matCellDef="let row"> {{ row.totalValue | currency:'EUR' }} </mat-cell>
            </ng-container>
      
          <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef i18n>Description</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <div [innerHtml]="row.description"></div>
            </mat-cell>
          </ng-container>
      
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [class.expanded]="expandedElement == row" (click)="expandedElement = row">
          </mat-row>
        </mat-table>
      
        <mat-paginator [length]="dataSource.resultsLength" [pageSizeOptions]="[25, 50, 100, 1000]"></mat-paginator>
      </div> -->
</mat-card>


// WEBPACK FOOTER //
// ./src/app/balances/components/activity-balance-table/activity-balance-table.component.html